// Palette centrale de l'application — source unique de vérité pour les couleurs
// pilotées en JavaScript (graphiques Recharts, SVG inline, sélecteurs de couleur).
// Pour tout le reste, préférer les classes Tailwind / variables CSS (index.css).
// L'équivalent Tailwind est indiqué en commentaire pour rester cohérent.

// Séries de graphiques (camembert secteurs, etc.)
export const CHART_COLORS = ["#10B981", "#3B82F6", "#F59E0B", "#8B5CF6", "#EF4444", "#14B8A6"];

// Pastels réutilisés par les tags, secteurs et zones d'anatomie
export const PASTEL_COLORS = [
  "#FCD34D", "#7DD3FC", "#F9A8D4", "#86EFAC", "#C4B5FD",
  "#FDA4AF", "#FDBA74", "#A7F3D0", "#93C5FD", "#DDD6FE",
];

// Jetons unitaires
export const INK = "#0F172A";            // slate-900 — texte
export const EMERALD = "#10B981";        // emerald-500 — accent primaire
export const BLUE = "#3B82F6";           // blue-500
export const SWATCH_DEFAULT = "#E2E8F0"; // slate-200 — couleur par défaut d'un sélecteur
export const CHART_GRID = "#F1F5F9";     // slate-100 — grille des graphiques
export const CHART_TRACK = "#E2E8F0";    // slate-200 — piste du donut
export const CHART_N1 = "#CBD5E1";       // slate-300 — séries N-1
